import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen pt-20 flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-3">分类不存在</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categoryArticles = articles.filter((a) => a.category === slug);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <section className="w-full px-6 md:px-10 pt-24 pb-10 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">{category.name}</span>
            </nav>

            <div className="flex items-start gap-6 mb-10">
              <div className="w-16 h-16 flex-shrink-0 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <div>
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                  {category.name}
                </h1>
                <p className="text-foreground-600 text-base max-w-2xl leading-relaxed">
                  {category.description}
                </p>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 mb-10">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length === 0 ? (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-foreground-500 text-base">该分类暂无内容，敬请期待</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard
                    key={article.slug}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    imageUrl={article.imageUrl}
                    date={article.date}
                    readTime={article.readTime}
                    categoryName={article.categoryName}
                    tags={article.tags}
                  />
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}